module.exports = __webpack_public_path__ + "img/snake.687dd4ab.jpeg";